import { FC, useState, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useSignOut } from "react-auth-kit";
import {
  StyledHeader,
  HeaderElement,
  HeaderLogoutButton,
  UserAvatar,
} from "./ui/styled";
import Modal from "./ui/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import AddNewEmployee from "./ui/AddNewEmployee";
import VacationSchedule from './ui/VacationSchedule';

const Header: FC = () => {
  const singOut = useSignOut();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedHeaderElem, setSelectedHeaderElem] = useState<{
    title: string;
    content?: ReactNode;
  }>({ title: "" });
  const handleModalOpen = (elem: { title: string; content?: ReactNode }) => {
    elem && setSelectedHeaderElem(elem);
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setSelectedHeaderElem({ title: "" });
    setIsModalOpen(false);
  };

  const handleLogout = () => {
    singOut();
    navigate("/login");
  };

  const headerElements: {
    [key: string]: {
      title: string;
      content?: ReactNode;
    };
  } = {
    addNew: {
      title: "Создать сотрудника",
      content: <AddNewEmployee />,
    },
    employee: {
      title: "Сотрудник",
    },
    report: {
      title: "Отчёты",
    },
    vacation: {
      title: "График отпусков",
      content: <VacationSchedule />,
    },
    service: {
      title: "Сервис",
    },
    important: {
      title: "Важная информация",
    },
  };

  return (
    <StyledHeader>
      {Object.keys(headerElements).map((key) => (
        <HeaderElement
          key={headerElements[key].title}
          onClick={() => handleModalOpen(headerElements[key])}
        >
          {headerElements[key].title}
        </HeaderElement>
      ))}
      <Box display="flex" alignItems="center" ml="auto" gap={2}>
        <UserAvatar
          onClick={() => handleModalOpen({ title: "Пользователь" })}
        />
        <HeaderLogoutButton onClick={handleLogout}>
          <CloseIcon />
        </HeaderLogoutButton>
      </Box>
      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        title={selectedHeaderElem.title}
        content={selectedHeaderElem.content}
      />
    </StyledHeader>
  );
};

export default Header;
